var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config)?_c('AuthView',{attrs:{"form":_vm.config,"formLoading":_vm.loading},on:{"submit":_vm.onSubmit,"input":_vm.onInput}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }